import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button } from 'antd';
import "./emailSent.css";

class ResetPasswordEmailSent extends Component {
  render() {
    return (
      <div>
        <h1>Password reset link sent</h1>
        <p>A password reset link was sent to <b className="troubles-logging-in-form__user-email">{this.props.email}</b></p>
        <p>Please check your mailbox</p>
        <Link to="/auth/login">
          <Button type="primary" className="troubles-logging-in-form__back-to-login-button">
            <b>BACK TO LOGIN</b>
          </Button>
        </Link>
      </div>
    );
  }
}

export default ResetPasswordEmailSent;



// WEBPACK FOOTER //
// ./src/components/pages/reset_password_request/email_sent.js